import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "crm:mb-8 crm:bg-white" }
const _hoisted_2 = { class: "crm:flex crm:justify-between crm:px-4 crm:py-2" }
const _hoisted_3 = { class: "crm:flex crm:flex-col crm:pr-4" }
const _hoisted_4 = { class: "crm:font-bold! crm:text-xl! crm:text-dark crm:mb-0" }
const _hoisted_5 = { class: "crm:mb-2" }
const _hoisted_6 = { class: "crm:text-xs" }
const _hoisted_7 = { class: "crm:mb-1" }
const _hoisted_8 = {
  key: 0,
  class: "crm:mb-0"
}
const _hoisted_9 = { class: "crm:flex-1" }
const _hoisted_10 = { class: "crm:mb-4" }
const _hoisted_11 = { class: "crm:p-4" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "crm:mt-8"
}
const _hoisted_14 = {
  key: 2,
  class: "crm:mt-8"
}
const _hoisted_15 = {
  key: 3,
  class: "crm:mt-8"
}
const _hoisted_16 = {
  key: 4,
  class: "crm:mt-8"
}

import AppProperties from "./AppProperties.vue";
import 'highlight.js/lib/common';
import 'highlight.js/styles/night-owl.css';
import hljsVuePlugin from "@highlightjs/vue-plugin/dist/highlightjs-vue.esm.min";


export default {
  __name: 'AppComponentsDocItem',
  props: {
  component: {
    type: Object,
    default() {
      return {}
    }
  },
  compKey: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props

const highlightjs = hljsVuePlugin.component

const getExamples = (item) => item.tags?.example[0]?.description

/**
 *
 * @param nomeComponente
 * @param props
 * @param slots
 * @return {string}
 */
function generaEsempio(nomeComponente, props, slots) {
  const propsPrint = props ? props.reduce(function (result, item) {
    return result + `\n:${item.name}="${getExamples(item) !== undefined ? getExamples(item) : '...'}" `;
  }, '') : '';

  const slotsPrint = slots ? slots.reduce(function (result, item) {
    return result + `${result !== '' ? '\n' : '\n'}<template #${item.name}>...</template>`;
  }, '') : '';

  return `<${nomeComponente} ${propsPrint}>
    ${slotsPrint}
</${nomeComponente}>`;
}


return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(__props.compKey), 1 /* TEXT */),
        _createElementVNode("p", _hoisted_5, [
          _createElementVNode("small", _hoisted_6, [
            _createElementVNode("i", null, _toDisplayString(__props.component.path), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("p", _hoisted_7, _toDisplayString(__props.component.description), 1 /* TEXT */),
        (__props.component['requires'] !== undefined && __props.component.requires)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
              _cache[0] || (_cache[0] = _createElementVNode("strong", null, "Richiede: ", -1 /* CACHED */)),
              _createTextVNode(" " + _toDisplayString(__props.component.requires), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_unref(highlightjs), {
          autodetect: "",
          code: generaEsempio(__props.compKey, __props.component.props, __props.component.slots)
        }, null, 8 /* PROPS */, ["code"])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      (__props.component.props && __props.component.props.length > 0)
        ? (_openBlock(), _createElementBlock("section", _hoisted_12, [
            _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "crm:text-lg! crm:px-4" }, "Props", -1 /* CACHED */)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.component.props, (prop) => {
              return (_openBlock(), _createBlock(AppProperties, { item: prop }, null, 8 /* PROPS */, ["item"]))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true),
      (__props.component.slots && __props.component.slots.length > 0)
        ? (_openBlock(), _createElementBlock("section", _hoisted_13, [
            _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "crm:text-lg! crm:px-4" }, "Slots", -1 /* CACHED */)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.component.slots, (prop) => {
              return (_openBlock(), _createBlock(AppProperties, { item: prop }, null, 8 /* PROPS */, ["item"]))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true),
      (__props.component.events && __props.component.events.length > 0)
        ? (_openBlock(), _createElementBlock("section", _hoisted_14, [
            _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "crm:text-lg! crm:px-4" }, "Events", -1 /* CACHED */)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.component.events, (prop) => {
              return (_openBlock(), _createBlock(AppProperties, { item: prop }, null, 8 /* PROPS */, ["item"]))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true),
      (__props.component.provides && __props.component.provides.length > 0)
        ? (_openBlock(), _createElementBlock("section", _hoisted_15, [
            _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "crm:text-lg! crm:px-4" }, "Provide", -1 /* CACHED */)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.component.provides, (prop) => {
              return (_openBlock(), _createBlock(AppProperties, { item: prop }, null, 8 /* PROPS */, ["item"]))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true),
      (__props.component.injects && __props.component.injects.length > 0)
        ? (_openBlock(), _createElementBlock("section", _hoisted_16, [
            _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "crm:text-lg! crm:px-4" }, "Inject", -1 /* CACHED */)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.component.injects, (prop) => {
              return (_openBlock(), _createBlock(AppProperties, { item: prop }, null, 8 /* PROPS */, ["item"]))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}
}

}